import React from "react";
import { Row, Col } from "reactstrap";
import { languageService } from "../../../Language/language.service";
import moment from "moment";
import { themeService } from "../../../theme/service/activeTheme.service";
import { versionInfo } from "../../MainPage/VersionInfo";

function Detail(props) {
  const maintenanceState = (d) => {
    if ((d && d.status === "Complete") || (d && d.status === "Closed")) {
      return "Closed";
    }

    let returnValue = {
      pending: languageService("Pending Review"),
      returned: languageService("Returned"),
      completed: languageService("Accepted"),
    };
    return returnValue[d.reviewState] || "Open";
  };
  const { m1 } = props;
  let issueTime =
    m1.issue && m1.issue.remedialAction && m1.issue.remedialAction === "Repaired" && m1.issue.timeStamp ? m1.issue.timeStamp : null;
  return (
    <div
      style={{
        margin: "0 0 10px 0",
        boxShadow: "rgb(207, 207, 207) 1px 1px 2px",
        padding: "15px",
        textAlign: "left",
        marginBottom: "20px",
      }}
    >
      <Row>
        <Col md={"12"}>
          <div style={props.fieldHeading}>{languageService("Issue#")} :</div>
          <div style={props.fieldText}>
            {props.m1.issue && props.m1.issue.serverObject && props.m1.issue.serverObject.issueNum
              ? props.m1.issue.serverObject.issueNum
              : "N/A"}
          </div>
        </Col>
        {props.m1.timestamp && (
          <Col md={"12"}>
            <div style={props.fieldHeading}>
              {languageService("Issue")} {languageService("Created at")}:{" "}
            </div>
            <div style={props.fieldText}>{moment(moment.utc(props.m1.timestamp).toDate()).format("llll")}</div>
          </Col>
        )}

        {props.m1.issue && props.m1.issue.unit && props.m1.issue.unit.unitId && (
          <Col md={"12"}>
            <div style={props.fieldHeading}>{languageService("Asset Name")}: </div>
            <div style={props.fieldText}>{props.m1.issue.unit.unitId}</div>
          </Col>
        )}

        {props.m1.workOrderNumber && (
          <Col md={"12"}>
            <div style={props.fieldHeading}>{languageService("Work Order")} #: </div>
            <div style={props.fieldText}>{props.m1.workOrderNumber}</div>
          </Col>
        )}
        <Col md={"12"}>
          <div style={props.fieldHeading}>{languageService("MR Number")} :</div>
          <div style={props.fieldText}>
            {/* <Gravatar style={{ borderRadius: '30px', marginRight: '5px' }} email={'abc@abc.com'} size={20} /> */}
            {props.m1.mrNumber}
          </div>
        </Col>

        {!versionInfo.isChargeCodeField() && props.m1.afeNumber && (
          <Col md={"12"}>
            <div style={props.fieldHeading}>{languageService("AFE #")} :</div>
            <div style={props.fieldText}>
              {/* <Gravatar style={{ borderRadius: '30px', marginRight: '5px' }} email={'abc@abc.com'} size={20} /> */}
              {props.m1.afeNumber}
            </div>
          </Col>
        )}

        {versionInfo.isChargeCodeField() && props.m1.chargeCode && (
          <Col md={"12"}>
            <div style={props.fieldHeading}>{languageService("Charge Code")} :</div>
            <div style={props.fieldText}>
              {/* <Gravatar style={{ borderRadius: '30px', marginRight: '5px' }} email={'abc@abc.com'} size={20} /> */}
              {props.m1.chargeCode}
            </div>
          </Col>
        )}

        <Col md={"12"}>
          <div style={props.fieldHeading}>{languageService("Maintenance Type")}: </div>
          <div style={props.fieldText}>{props.m1.maintenanceType ? languageService(props.m1.maintenanceType) : ""}</div>
        </Col>
        <Col md={"12"}>
          <div style={props.fieldHeading}>{languageService("Information")}:</div>
          <div style={{ ...props.fieldText, maxWidth: "265px", wordWrap: "break-word" }}>
            {props.m1.issue && props.m1.issue.voiceNotes ? props.m1.issue.voiceNotes : ""}
          </div>
        </Col>
        {issueTime ? (
          <Col md={"12"}>
            <div style={props.fieldHeading}>MR {languageService("Created at")}: </div>
            <div style={props.fieldText}>{moment.utc(issueTime).local().format("llll")}</div>
          </Col>
        ) : (
          moment(props.m1.createdAt).isValid() && (
            <Col md={"12"}>
              <div style={props.fieldHeading}>MR {languageService("Created at")}: </div>
              <div style={props.fieldText}>{moment(props.m1.createdAt).format("llll")}</div>
            </Col>
          )
        )}
        {
          <Col md={"12"}>
            <div style={props.fieldHeading}>{languageService("Created by")}: </div>
            {props.getUserDisplay(props.m1.createdBy, props.execution)}
          </Col>
        }

        <Col md={"12"}>
          <div style={props.fieldHeading}>{languageService("Status")}: </div>
          <div style={props.fieldText}>{languageService(props.m1.status)}</div>
        </Col>

        {/* <Col md={"3"}>
            <div style={props.fieldHeading}>{languageService("Marked On Site")}</div>
            <div style={props.fieldText}>{m1.markedOnSite ? m1.markedOnSite.toString() : ""}</div>
          </Col> */}

        {/* <Col md={"12"}>
          <div style={props.fieldHeading}>{languageService("Priority")}: </div>
          <div style={props.fieldText}>{props.m1.priority}</div>
        </Col> */}
        <Col md={"12"}>
          <div style={props.fieldHeading}>{languageService("Source")}: </div>
          <div style={props.fieldText}>{languageService(props.m1.sourceType)}</div>
        </Col>
        <Col md={"12"}>
          <div style={props.fieldHeading}>{languageService("Priority")}: </div>
          <div style={props.fieldText}>{languageService(props.m1.priority)}</div>
        </Col>
        {(versionInfo.getApplicationType() === "TIMPS" || versionInfo.getApplicationType() === "SITE") && (
          <Col md={"12"}>
            <div style={props.fieldHeading}>{languageService("State")}: </div>
            <div style={props.fieldText}>{languageService(maintenanceState(props.m1))}</div>
          </Col>
        )}

        {/* <Col md="1">{showAddButton}</Col> */}
      </Row>
    </div>
  );
}

export default Detail;



// WEBPACK FOOTER //
// ./src/components/Maintenance/MaintenanceDetail/MaintenanceDetail.js